import { RECEIVE_CARD_STATEMENT_UPLOAD_DIFFS, REVIEW_CARD_HOLDERS, REVIEW_DUPLICATES, SET_DIFFS_TO_APPLY, UPDATE_ADD_CARD_DIFF_CARD_HOLDER } from '@Actions/bulk_upload';
import { CLEAR_PROCESSING_FAILURE, RECORD_PROCESSING_FAILURE, SAVE_CSV_DATA } from '@Actions/index';
const defaultState = {
    loadingDiffs: false,
    allDiffs: [],
    addCardDiffs: [],
    addTransactionDiffs: [],
    errorDiffs: [],
    error: null,
    openTab: null,
    savedFile: null,
    fileType: null,
    reviewedCardHolders: false,
    reviewedDuplicates: false
};
export function cardStatementUploadReducer(state = defaultState, action) {
    switch (action.type) {
        case RECEIVE_CARD_STATEMENT_UPLOAD_DIFFS:
            return Object.assign({}, state, {
                loadingDiffs: false,
                allDiffs: action.diffs,
                addCardDiffs: action.diffs.filter((diff) => diff.action === 'ADD_CARD'),
                addTransactionDiffs: action.diffs.filter((diff) => diff.action === 'ADD_TRANSACTION')
            });
        case UPDATE_ADD_CARD_DIFF_CARD_HOLDER: {
            const { userId, temporaryAccountId } = action;
            const addCardDiffs = state.addCardDiffs;
            const assignedCardDiff = addCardDiffs.find((cardDiff) => cardDiff.id === temporaryAccountId);
            assignedCardDiff.userId = userId;
            return Object.assign({}, state, { addCardDiffs });
        }
        case SET_DIFFS_TO_APPLY: {
            const { diffs } = action;
            const mapIds = {};
            for (const diff of diffs) {
                mapIds[diff.id] = true;
            }
            const addTransactionDiffs = [...state.addTransactionDiffs];
            for (const diff of addTransactionDiffs) {
                if (mapIds[diff.id]) {
                    diff.skip = false;
                }
                else {
                    diff.skip = true;
                }
            }
            return Object.assign({}, state, { addTransactionDiffs });
        }
        case REVIEW_CARD_HOLDERS:
            return Object.assign({}, state, {
                reviewedCardHolders: action.reviewed
            });
        case REVIEW_DUPLICATES:
            return Object.assign({}, state, {
                reviewedDuplicates: action.reviewed
            });
        case RECORD_PROCESSING_FAILURE:
            return Object.assign({}, state, {
                error: action.error,
                errorDiffs: action.diffs.filter((diff) => diff.fieldErrorMap && Object.keys(diff.fieldErrorMap).length)
            });
        case CLEAR_PROCESSING_FAILURE:
        case 'CLOSE_MODAL':
            return Object.assign({}, defaultState);
        case SAVE_CSV_DATA:
            return Object.assign({}, state, {
                savedFile: action.data,
                fileType: action.fileType
            });
        default:
            return state;
    }
}
